export default __webpack_public_path__ + "logo846aef7.png";